<template>
  <div class="operation-licenses-list">
    <div v-if="operation && showOperationName" class="row">
      <div class="col-12">{{ operation.name }}</div>
    </div>
    <div v-if="stateLicense" class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 overflow-hidden">
            <div v-if="showLicenseType">
              <p class="text-sm text-nowrap mb-0">State License Number</p>
              <div class="clearfix mb--half" />
            </div>

            <span class="text-nowrap">
              {{ stateLicense }}
            </span>
            <a
              v-if="isDownloadable && stateLicenseDoc"
              :href="`/b-api/operations/state-license-doc/download/${stateLicenseDoc}`"
              target="_blank"
              class="download-link ml-1"
            >
              <svg class="download-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="licenses && licenses.length">
      <div v-for="license in licenses" :key="license.id" class="row">
        <div class="col-12">
          <div v-if="showLicenseType">
            <p class="text-nowrap mb-0">
              {{ license.type }}
            </p>
            <div class="clearfix mb--half" />
          </div>

          <span class="text-nowrap">
            {{ license.number }}
          </span>
          <span v-if="license.documents && license.documents.length > 0">
            <div v-for="doc in license.documents" :key="doc.uuid" class="mb-1 d-inline-block">
              <a v-if="isDownloadable" :href="downloadLink(doc)" :download="doc.name" target="_blank" class="download-link ml-1">
                <svg class="download-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
              </a>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFileName } from "@/services/helpers";

export default {
  props: {
    licenses: { type: Array, required: false },
    isDownloadable: { type: Boolean, default: false },
    stateLicense: { type: String, required: false },
    stateLicenseDoc: { type: String, required: false },
    operation: { type: Object, required: false },
    showOperationName: { type: Boolean, default: false },
    showLicenseType: { type: Boolean, default: false },
  },
  methods: {
    downloadLink(document) {
      const link = document.id ? `/b-api/docs/public-download/${document.uuid}` : document.file;
      return link;
    },
    getFileName,
  },
};
</script>
<style scoped lang="scss">
/* Ensure all text uses rem-based sizing for proper PDF scaling */
.operation-licenses-list {
  font-size: 0.875rem;

  span,
  p,
  div {
    font-size: inherit !important;
  }
}

.download-link {
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  color: inherit;
  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.8;
  }
}

.download-icon {
  display: inline-block;
  height: 1rem;
  width: 1rem;
  vertical-align: middle;
  color: currentColor;
}
</style>
